/**
 * Días con servicio MuniBus: lunes a viernes que no son feriado nacional
 * (`feriados.json`, copia generada de data/feriados.json por scripts/generate_horarios.py).
 * Siempre en hora de Chile: la persona puede tener el teléfono en otra zona horaria.
 */
import feriadosData from '@/data/recorridos/feriados.json';

const FERIADOS = new Map(feriadosData.feriados.map((f) => [f.fecha, f.nombre]));

const FECHA_SANTIAGO = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago' });
const DIA_SANTIAGO = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Santiago', weekday: 'short' });

/** Fecha de hoy en Chile (YYYY-MM-DD). */
export const hoySantiago = (ahora = new Date()) => FECHA_SANTIAGO.format(ahora);

/**
 * Motivo por el que hoy no hay servicio («sábado», «domingo» o el nombre del feriado), o null.
 * @param {Date} [ahora]
 */
export function motivoSinServicioHoy(ahora = new Date()) {
  const feriado = FERIADOS.get(hoySantiago(ahora));
  if (feriado) return `feriado: ${feriado}`;
  const dia = DIA_SANTIAGO.format(ahora);
  if (dia === 'Sat') return 'sábado';
  if (dia === 'Sun') return 'domingo';
  return null;
}
